/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  VideoInput,
  VideoInputFromJSON,
  VideoInputFromJSONTyped,
  VideoInputToJSON,
} from "./";

/**
 *
 * @export
 * @interface VoteInput
 */
export interface VoteInput {
  /**
   *
   * @type {number}
   * @memberof VoteInput
   */
  regularVimeoAlbumId: number;
  /**
   *
   * @type {number}
   * @memberof VoteInput
   */
  charitableVimeoAlbumId: number;
  /**
   *
   * @type {number}
   * @memberof VoteInput
   */
  umbracoId: number;
  /**
   *
   * @type {string}
   * @memberof VoteInput
   */
  email: string;
  /**
   *
   * @type {Array<VideoInput>}
   * @memberof VoteInput
   */
  regularVideos: Array<VideoInput>;
  /**
   *
   * @type {Array<VideoInput>}
   * @memberof VoteInput
   */
  charitableVideos: Array<VideoInput>;
  /**
   *
   * @type {boolean}
   * @memberof VoteInput
   */
  remindNextYear?: boolean;
}

export function VoteInputFromJSON(json: any): VoteInput {
  return VoteInputFromJSONTyped(json, false);
}

export function VoteInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoteInput {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    regularVimeoAlbumId: json["regularVimeoAlbumId"],
    charitableVimeoAlbumId: json["charitableVimeoAlbumId"],
    umbracoId: json["umbracoId"],
    email: json["email"],
    regularVideos: (json["regularVideos"] as Array<any>).map(
      VideoInputFromJSON,
    ),
    charitableVideos: (json["charitableVideos"] as Array<any>).map(
      VideoInputFromJSON,
    ),
    remindNextYear: !exists(json, "remindNextYear")
      ? undefined
      : json["remindNextYear"],
  };
}

export function VoteInputToJSON(value?: VoteInput | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    regularVimeoAlbumId: value.regularVimeoAlbumId,
    charitableVimeoAlbumId: value.charitableVimeoAlbumId,
    umbracoId: value.umbracoId,
    email: value.email,
    regularVideos: (value.regularVideos as Array<any>).map(VideoInputToJSON),
    charitableVideos: (value.charitableVideos as Array<any>).map(
      VideoInputToJSON,
    ),
    remindNextYear: value.remindNextYear,
  };
}
